/*
 * File: ToolTip.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 4, 2025 at 10:29 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';

// Components
import { Typography } from '../Typography';


/**
 * Constants
 */

export const SIZES = {
	small: '0.7rem',
	medium: '0.8rem',
	large: '0.9rem',
};


/**
 * Styles
 */

export const ToolTip = styled(ReactTooltip)`
	&.__react_component_tooltip {
		background-color: ${({ theme }) => theme.surfaceBackground} !important;
		color: ${({ theme }) => (theme.primaryText)} !important;
		border-radius: 8px;
		padding: 8px 12px;
		max-width: calc(100% - 32px);
		box-shadow: ${({ theme }) => theme.surfaceShadow};
		height: auto;

		&.show {
			opacity: 1;
		}
		&::before,
		&::after {
			background-color: ${({ theme }) => theme.surfaceBackground} !important;
		}
		&::after {
			border: 1px solid #c2c3c1 !important;
		}
		&.place-top::before {
			bottom: -1px !important;
		}
		&.place-right::before {
			left: -1px !important;
		}
		&.place-left::before {
			right: -1px !important;
		}
		&.place-top::after,
		&.place-right::after,
		&.place-left::after {
			border-top-right-radius: 2px !important;
		}
		&.place-bottom::before {
			margin-left: -9px !important;
			top: -1px !important;
		}
		&.place-bottom::after {
			border-top-left-radius: 2px;
			border: 1px solid #dcdcdc !important;
		}
		* {
			color: ${({ theme }) => (theme.primaryText)} !important;
		}
	}
`;

export const Inner = styled(Typography)`
	font-size: ${({ size }) => SIZES[size]};

	svg {
		margin-right: 6px;
		margin-left: 0px;

		&.success {
			color: ${({ theme }) => theme.statusSuccessBase};
		}
		&.error {
			color: ${({ theme }) => theme.statusDangerBase};
		}
	}
`;
